import React from 'react';
import { H1, Tag } from '@blueprintjs/core';

import { useAppSelector } from '../../../hooks';

import { AuthState } from '../types';

const UserProfile = () => {
  const { profile }: AuthState = useAppSelector((state) => state.auth);

  if (!profile) {
    return null;
  }

  const { username, email, roles } = profile;

  return (
    <div
      className="user-profile"
      style={{ maxWidth: '400px', margin: '0 auto', padding: '20px' }}
    >
      <H1>Perfil do Usuário</H1>
      <p>
        <strong>Nome de Usuário:</strong> {username}
      </p>
      <p>
        <strong>Email:</strong> {email}
      </p>
      <p>
        <strong>Papéis:</strong>
      </p>
      <div>
        {roles.map((role, index) => (
          <Tag key={index} style={{ marginRight: '5px' }}>
            {role}
          </Tag>
        ))}
      </div>
    </div>
  );
};

export default UserProfile;
